import { Stores } from '../../../libraries/storage/constants';

/**
 * @constant
 * Size of the internal buffer of BufferedEventJournaler when it
 * petitions PersistenceOrchestrator for a trasactional write
 **/
export const BATCH_SIZE_SOFT_LIMIT = 100;

/**
 * @constant
 * Number of events EventJournalConsumer fetches from journal at a time
 * from the journal
 */
export const CONSUMER_BATCH_SIZE = 1000;

/**
 * @constant
 * Time interval in ms. Determines how frequently EventJournalConsumer runs the consumption logic (sync to backend)
 */
export const CONSUMER_INTERVAL_MS = 10_000;

/**
 * Time interval in ms after which PersistenceOrchestrator, performs coordinated write
 * unless it receives petitions to write
 */
export const ORCHESTRATOR_INTERVAL_MS = 5_000;

/**
 * @constant
 * Number of times EventJournalConsumer retries consumption (syncing to backend) of same batch
 * before declaring failure
 */
export const MAX_CONSECUTIVE_FAILURES = 3;

/**
 * Key is `taskID___videoID__frameIndex___annotationID`
 * DO NOT CHANGE THIS! It will impact events persisted to journal in IDB
 */
export const OBJECT_KEY_DELIMITER = '___';
export const IDB_STORE_JOURNAL = Stores.VideoEventsJournal;